import backEnd from '../constants/backEnd';
import endpoints from '../constants/endpoints';

import formatEmail from '../utils/formatEmail';
import { getCSRF } from './getCSRF';

export async function logar(username, password, company) {
  let csrf = await getCSRF();

  return fetch(`${backEnd.url}${endpoints.access.login}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "X-CSRFToken": csrf?.csrfToken,
    },
    body: JSON.stringify({
      client_palo: company.trim(),
      username: formatEmail(username.trim()),
      password: password,
      system: 'GESTÃO',
    }),
  }).then(async retorno => {
    let dados = await retorno.json();
    if (retorno.status !== 200) {
      throw new Error(dados.detail);
    }
    return dados;
  });
}
